import React from 'react'
import { Link } from 'react-router-dom'
import { FiArrowUpRight, FiInstagram, FiMapPin, FiPhone } from 'react-icons/fi'
import { useStudio } from '../context/StudioContext'
import { resolveMediaUrl } from '../services/api'

export default function Contact() {
  const { studio } = useStudio()

  return (
    <div className="pb-20">
      <section className="section-shell page-section">
        <div className="surface-card grid gap-8 overflow-hidden px-6 py-10 sm:px-10 lg:grid-cols-[1fr_0.85fr] lg:items-center">
          <div>
            <p className="eyebrow">Contact</p>
            <h1 className="mt-4 font-heading text-5xl text-stone-900 sm:text-6xl">Reach the studio the same way clients do from Instagram.</h1>
            <p className="mt-4 max-w-2xl text-sm leading-7 text-stone-600 sm:text-base">
              The public profile asks guests to book by phone or message. This page turns that into a cleaner contact experience for the site, with direct links, Tampa location context, and a clear route into the booking flow.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/booking" className="primary-button">Open booking</Link>
              <a
                href={studio?.instagramUrl || 'https://www.instagram.com/maya__nails/'}
                target="_blank"
                rel="noopener noreferrer"
                className="secondary-button inline-flex items-center gap-2"
              >
                <FiInstagram />
                Message on Instagram
              </a>
            </div>
          </div>

          <div className="overflow-hidden rounded-[2rem] bg-stone-100">
            <img
              src={resolveMediaUrl('/instagram/laser-diode.jpg')}
              alt="Maya Nails laser care"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="grid gap-6 lg:grid-cols-[0.95fr_1.05fr]">
          <div className="surface-card p-8 sm:p-10">
            <p className="eyebrow">Contact methods</p>
            <div className="mt-6 space-y-4">
              <a href={studio ? `tel:+1${studio.phone}` : 'tel:+18138503700'} className="booking-link">
                <FiPhone className="text-rose-700" />
                <span>{studio?.phoneDisplay || '(813) 850-3700'}</span>
              </a>
              <a href={studio?.instagramUrl || 'https://www.instagram.com/maya__nails/'} target="_blank" rel="noopener noreferrer" className="booking-link">
                <FiInstagram className="text-rose-700" />
                <span>{studio?.handle || '@maya__nails'}</span>
              </a>
              <div className="booking-link">
                <FiMapPin className="text-rose-700" />
                <span>{studio?.city || 'Tampa, Florida'}</span>
              </div>
            </div>
          </div>

          <div className="surface-card p-8 sm:p-10">
            <p className="eyebrow">What to send when you reach out</p>
            <div className="mt-6 grid gap-5 md:grid-cols-2">
              {[
                'Tell the studio whether you want nails, brows, beauty support, or a laser consultation.',
                'If you want laser service, mention the area you are targeting and whether this is your first session.',
                'If you want nails, share your preferred finish or inspiration so the booking can be scoped correctly.',
                'Mention if you prefer English or Espanol so the conversation starts in the most comfortable language.',
              ].map((item) => (
                <div key={item} className="rounded-[1.75rem] bg-stone-100 px-5 py-5 text-sm leading-7 text-stone-600">
                  {item}
                </div>
              ))}
            </div>

            <a
              href={studio?.instagramUrl || 'https://www.instagram.com/maya__nails/'}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.16em] text-stone-700"
            >
              Open the public Instagram profile
              <FiArrowUpRight />
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}
